import { getUser } from "./auth";

export const canAccess = (permission) => {
  const user = getUser();
  if (!user) return false;

  const role = user.role;

  const rules = {
    SYSTEM_ADMIN: [
      "SYSTEM_SETUP",
      "JIMBO",
      "PAROKIA",
      "KANDA",
      "JUMUIA",
    ],
    PAROKIA_ADMIN: [
      "SYSTEM_SETUP",
      "KANDA",
      "JUMUIA",
    ],
  };

  return rules[role]?.includes(permission) || false;
};
